/**
 * Created by neo on 02.12.20.
 *
 * Simplified: Only stores activityLogId for navigation.
 * All display properties (title, subtitle, media, etc.) are pre-resolved on the entry level.
 *
 * Plain TypeScript type - no MobX observables.
 */
import { WeekDayEntryBase, parseWeekDayEntry } from './WeekDayEntry';
import { v4 as UUID } from 'uuid';

export type WeekDayEntryActivityLog = WeekDayEntryBase & {
  type: 'activityLog';
  activityLogId: string;
  activityLog?: { id: string };
};

export function parseWeekDayEntryActivityLog(json?: any): WeekDayEntryActivityLog {
  return {
    ...parseWeekDayEntry({ ...json, id: json?.activityLog?.id ?? UUID(), type: 'activityLog' }),
    type: 'activityLog' as const,
    activityLogId: json?.activityLog?.id ?? '',
  };
}

/** @deprecated Use parseWeekDayEntryActivityLog instead */
export const createWeekDayEntryActivityLog = parseWeekDayEntryActivityLog;
